module.exports = __webpack_public_path__ + "img/11.b8e0e0fd.jpg";